import React from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton, Typography } from '@mui/material';

const AddButton = ({ className, children, disabled, onClick, testId = '' }) => {
  const hasDisabledClass = Boolean(className && /\bdisabled\b/.test(className));
  const isDisabled = disabled || hasDisabledClass;
  const ariaLabel = typeof children === 'string' && children.trim() ? children : 'Add';

  return (
    <Box
      type="button"
      component="button"
      className={`add-button ${className || ''}`.trim()}
      aria-label={ariaLabel}
      data-testid={testId}
      onClick={onClick}
      disabled={isDisabled}
      sx={{
        alignItems: 'center',
        backgroundColor: 'transparent',
        border: 0,
        cursor: isDisabled ? 'default' : 'pointer',
        display: 'inline-flex',
        font: 'inherit',
        height: '37px',
        justifyContent: 'flex-start',
        m: 0,
        p: 0,
        width: 'fit-content',
      }}
    >
      <IconButton
        component="span"
        disableRipple
        size="small"
        sx={{
          backgroundColor: '#BE53D2',
          borderRadius: '2px',
          color: '#FFFFFF',
          height: '20px',
          minHeight: '20px',
          minWidth: '20px',
          p: 0,
          width: '20px',
          '&:hover': {
            backgroundColor: '#BE53D2',
          },
          '& .MuiSvgIcon-root': {
            fontSize: '16px',
          },
        }}
      >
        <AddIcon />
      </IconButton>
      {children && (
        <Typography
          component="span"
          sx={{
            color: '#120027',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.2,
            ml: '10px',
          }}
        >
          {children}
        </Typography>
      )}
    </Box>
  );
};

export default AddButton;

AddButton.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  onClick: undefined,
};

AddButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  testId: PropTypes.string,
};
